import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';

const LoginPage = () => {
  const { login } = useAuth();

  return (
    <GoogleOAuthProvider clientId="1026075212507-fga5degt5a2ir64snu8hu7kp9gffebog.apps.googleusercontent.com">
      <div className="flex items-center justify-center h-screen bg-background">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-8">Welcome to Marketing Tool</h1>
          <GoogleLogin
            onSuccess={credentialResponse => {
              login();
            }}
            onError={() => {
              console.log('Login Failed');
            }}
          />
        </div>
      </div>
    </GoogleOAuthProvider>
  );
};

export default LoginPage;
